import React from "react";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";

interface Props {
  label: React.ReactNode;
  isSelected: boolean;
  isCurrentStage: boolean;
  onClick: () => void;
  rightAdornment?: React.ReactNode;
  dataTest?: string;
}

const WorkflowSelectorButton: React.FC<Props> = ({
  label,
  isSelected,
  isCurrentStage,
  onClick,
  rightAdornment,
  dataTest
}) => (
  <div
    onClick={onClick}
    data-test={dataTest}
    className={cn(
      "flex cursor-pointer rounded-xl border-[0.5px] pl-4 p-3 transition-all duration-200 ease-in-out",
      isSelected
        ? "border-border-border1 bg-surface-elevation1 shadow-popUp"
        : "border-transparent hover:bg-surface-hover-soft"
    )}
  >
    <div className="flex items-center gap-2 flex-1 min-w-0">
      <Text
        variant={
          isSelected ? "lgLabel" : !isCurrentStage ? "lgBodyTertiary" : "lgBody"
        }
        className="line-clamp-2"
      >
        {label}
      </Text>
    </div>
    {rightAdornment && (
      <div className="flex-shrink-0 ml-2">{rightAdornment}</div>
    )}
  </div>
);

export default WorkflowSelectorButton;
